import { FONTS_CONFIG, loadGoogleFonts } from './fonts';

export const initializeFontSystem = () => {
  // Ensure root element exists and has default font
  const root = document.documentElement;
  
  // Get current font value or set default
  const currentFont = getComputedStyle(root).getPropertyValue('--company-font').trim();
  
  if (!currentFont || currentFont === '') {
    root.style.setProperty('--company-font', FONTS_CONFIG.montserrat.css);
  }

  // Pre-load common Google Fonts on app startup for better performance
  const commonFonts = [
    'montserrat',
    'poppins',
    'playfair_display',
  ];
  
  loadGoogleFonts(commonFonts);
};
export const applyFontVariable = (fontKey) => {
  if (!fontKey || typeof fontKey !== 'string') {
    return;
  }

  // Check if fontKey exists in FONTS_CONFIG
  if (fontKey in FONTS_CONFIG) {
    const config = FONTS_CONFIG[fontKey];
    document.documentElement.style.setProperty(
      '--company-font',
      config.css
    );

    if (config.googleFont) {
      loadGoogleFonts([fontKey]);
    }
  }
}

export default {
  initializeFontSystem,
  applyFontVariable,
};


export const getCompanyFontCSS = () => {
  return getComputedStyle(document.documentElement)
    .getPropertyValue('--company-font')
    .trim() || FONTS_CONFIG.montserrat.css;
};
